<template>
  <v-app :class="{ mobile: is_mobile }">
    <div
      class="default-scrollbar"
      ref="defaultScrollbar"
      v-bar="{ preventParentScroll: true, scrollThrottle: 30, resizeRefresh: true }"
    >
      <div>
        <Login v-if="!login_data.logged" />
        <div v-else>
          <v-overlay
            :value="get_interface.overlay"
            @click="$store.dispatch('setOverlay', false)"
            color="#ffffff"
            z-index="199"
            :dark="$vuetify.theme.dark"
          ></v-overlay>
          <router-view name="header" />
          <v-main class="default-content">
            <transition
              mode="out-in"
              enter-active-class="animate__animated animate__fadeIn"
              leave-active-class="animate__animated animate__fadeOut"
              :duration="252"
              appear
            >
              <router-view v-slot="{ Component }">
                <keep-alive>
                  <suspense>
                    <component :is="Component"/>
                  </suspense>
                </keep-alive>
              </router-view>
            </transition>
          </v-main>
          <router-view name="footer" />
        </div>
      </div>
      <SnackBar />
    </div>
  </v-app>
</template>

<script>
import Login from './views/Login'
import SnackBar from './templates/main/components/SnackBar'

import appdata from '@/mixins/appdata'
import interface_ from '@/mixins/interface_'
import init_ from '@/mixins/defaults/init.js'

export default {
  name: 'App',
  mixins: [ appdata, interface_, init_ ],
  components: { Login, SnackBar }
}
</script>

<style src="@/styles/index.scss" lang="scss"></style>
